import { create } from "zustand";
import {
  PDA1121_R01Dto,
  PDA1121_R01SearchParams,
  RequiredItem,
  ScanResult,
} from "./PDA1121_R01Dto";

export interface PDA1121_R01Store {
  orderList: PDA1121_R01Dto[];
  selectedOrder: PDA1121_R01Dto | null;
  loading: boolean;
  searchParams: PDA1121_R01SearchParams;

  showList: boolean;
  requiredItems: RequiredItem[];

  itemCdInput: string;
  scanResult: ScanResult | null;   // 마지막 1건만

  setOrderList: (l: PDA1121_R01Dto[]) => void;
  setSelectedOrder: (o: PDA1121_R01Dto | null) => void;
  setLoading: (v: boolean) => void;
  updateSearchParam: (f: keyof PDA1121_R01SearchParams, v: string) => void;

  setShowList: (v: boolean) => void;
  setRequiredItems: (l: RequiredItem[]) => void;

  setItemCdInput: (v: string) => void;
  setScanResult: (r: ScanResult | null) => void;

  resetDetail: () => void;
  reset: () => void;
}

const fmt = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const today = new Date();
const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

const initialSearchParams: PDA1121_R01SearchParams = {
  productWorkNo: "",
  startDate: fmt(firstDay),
  endDate: fmt(today),
};

const usePDA1121_R01Store = create<PDA1121_R01Store>((set) => ({
  orderList: [],
  selectedOrder: null,
  loading: false,
  searchParams: initialSearchParams,

  showList: true,
  requiredItems: [],

  itemCdInput: "",
  scanResult: null,

  setOrderList: (l) => set({ orderList: l }),
  setSelectedOrder: (o) => set({ selectedOrder: o }),
  setLoading: (loading) => set({ loading }),
  updateSearchParam: (f, v) =>
    set((s) => ({ searchParams: { ...s.searchParams, [f]: v } })),

  setShowList: (v) => set({ showList: v }),
  setRequiredItems: (l) => set({ requiredItems: l }),

  setItemCdInput: (v) => set({ itemCdInput: v }),
  setScanResult: (r) => set({ scanResult: r }),

  resetDetail: () =>
    set({
      selectedOrder: null,
      requiredItems: [],
      itemCdInput: "",
      scanResult: null,
    }),

  reset: () =>
    set({
      orderList: [],
      selectedOrder: null,
      loading: false,
      searchParams: initialSearchParams,
      showList: true,
      requiredItems: [],
      itemCdInput: "",
      scanResult: null,
    }),
}));

export default usePDA1121_R01Store;
